import { render, staticRenderFns } from "./MenuProcesso.vue?vue&type=template&id=89bf8fc2&scoped=true"
import script from "./MenuProcesso.vue?vue&type=script&lang=js"
export * from "./MenuProcesso.vue?vue&type=script&lang=js"
import style0 from "./MenuProcesso.vue?vue&type=style&index=0&id=89bf8fc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bf8fc2",
  null
  
)

export default component.exports